import { ApiError, OfflineError } from '../api/http';

/**
 * Why a list a step needs did not arrive: the platform refused this account
 * (403), or anything else — the network, the panel, a fault.
 *
 * The quick start used to turn every failed load into an empty list, and an
 * empty list into the sentence for "there is none": a member whose account
 * could not read the servers was told the platform could not use any server
 * yet, and the owner looked for a server fault (2026-10-11). A list that did
 * not arrive is not an empty list, and the page says which of the two it is
 * (`LoadProblemNote`).
 */
export type LoadProblem = 'forbidden' | 'failed' | 'offline';

/** `offline`: the request never reached the platform (`OfflineError`), and the device keeps no copy. */
export function problemOf(err: unknown): LoadProblem {
  if (err instanceof OfflineError) return 'offline';
  return err instanceof ApiError && err.status === 403 ? 'forbidden' : 'failed';
}
